import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BTechFashionTechnologyCoursePage: React.FC = () => {
  const courseData = {
    title: "B.Tech Fashion Technology",
    shortName: "B.Tech Fashion Tech",
    duration: "4 Years",
    description: "Study fashion design, textile technology, apparel production, and fashion marketing.",
    overview: "B.Tech Fashion Technology is a 4-year undergraduate program focused on fashion design, textile engineering, garment manufacturing, and fashion marketing. The course prepares students for careers in fashion, apparel, and textile industries.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Valid entrance exam score (State CET/University Test)",
      "Interest in fashion and textiles"
    ],
    curriculum: [
      {
        year: 1,
        subjects: [
          "Textile Science",
          "Fashion Design Basics",
          "Fiber and Yarn Technology",
          "Engineering Graphics",
          "Apparel Production"
        ]
      },
      {
        year: 2,
        subjects: [
          "Garment Manufacturing",
          "Textile Testing",
          "Fashion Illustration",
          "Pattern Making",
          "Fabric Structure",
          "Fashion Communication"
        ]
      },
      {
        year: 3,
        subjects: [
          "Fashion Marketing",
          "CAD for Fashion",
          "Quality Control",
          "Apparel Merchandising",
          "Textile Finishing",
          "Internship"
        ]
      },
      {
        year: 4,
        subjects: [
          "Sustainable Fashion",
          "Fashion Forecasting",
          "Project Work",
          "Industrial Training"
        ]
      }
    ],
    careerProspects: {
      roles: [
        "Fashion Technologist",
        "Apparel Production Manager",
        "Textile Designer",
        "Fashion Consultant",
        "Quality Analyst",
        "Fashion Marketer"
      ],
      industries: [
        "Fashion Houses",
        "Textile Mills",
        "Apparel Manufacturing",
        "Retail Brands",
        "Export Houses"
      ],
      averageSalary: "₹3-6 LPA (Fresher), ₹8-15 LPA (Experienced)",
      topRecruiters: [
        "Raymond",
        "Arvind Mills",
        "Aditya Birla Fashion",
        "Fabindia",
        "Pantaloons",
        "Shahi Exports"
      ]
    },
    admissionProcess: [
      "State CET/University Entrance",
      "Counseling and seat allocation",
      "Direct admission based on 12th marks (in some colleges)"
    ],
    topColleges: [
      {
        name: "NIFT Delhi",
        location: "Delhi",
        fees: "₹10,00,000",
        ranking: "Top Fashion Institute"
      },
      {
        name: "Anna University",
        location: "Chennai",
        fees: "₹2,50,000",
        ranking: "NIRF Ranking: 35"
      },
      {
        name: "PSG College of Technology",
        location: "Coimbatore",
        fees: "₹4,50,000",
        ranking: "NIRF Ranking: 42"
      }
    ],
    skills: [
      "Fashion Design",
      "Textile Technology",
      "Apparel Production",
      "CAD for Fashion",
      "Fashion Marketing",
      "Quality Control",
      "Project Management"
    ],
    futureScope: "Growing opportunities in sustainable fashion, global apparel exports, fashion technology startups, and retail brands.",
    faqs: [
      {
        question: "Is B.Tech Fashion Technology different from B.Des Fashion Design?",
        answer: "Yes, B.Tech focuses more on technology, engineering, and production, while B.Des is more design-oriented."
      },
      {
        question: "Can I start my own fashion brand?",
        answer: "Yes, the course provides skills for entrepreneurship in fashion and apparel."
      },
      {
        question: "Are internships mandatory?",
        answer: "Yes, most colleges require internships for practical exposure."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0a183d] via-black to-[#1a2746] flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow animate-glow mb-8 text-center">
        {courseData.title}
      </h1>
      <div className="w-full max-w-5xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BTechFashionTechnologyCoursePage;
